import { BookingApproveFormFieldsEnum } from "@ryde/controls";
import { yupLocalized } from "@ryde/shared";

export const bookingBulkSetConflictApprovalReasonValidationSchema = {
  [BookingApproveFormFieldsEnum.APPROVAL_REASON_ID]: yupLocalized
    .number()
    .required(),
  [BookingApproveFormFieldsEnum.APPROVER]: yupLocalized.string().required(),
};
